import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { latestVersionFlowSelector } from '../../../features/serverBots/selectors'

export function useIsBotReady() {
  return !!useSelector<RootState>(latestVersionFlowSelector)
}
